import { getPointTableRequest } from "../repositories/point_table_repository";
export const PointsTableService = () => {
    const fetchPointsTable = async (setPointsTableData) => {
        try {
            const response = await getPointTableRequest();
            if (response?.success) {
                setPointsTableData(response.data);
            }
        } catch (error) {
            console.error("Failed to fetch point table data.");
        }
    };
    return {
        fetchPointsTable,
    };
};